import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';
import { WindowLocationServiceInterface } from 'pf-frontend-common/src/service/window-location/service.interface';

import { BackendConfigSettingsInterface } from 'common/data/backend/config/settings.interface';
import { settingsGetPageType } from 'common/helper/settings/get-page-type';
import { BuildingReviewButtonTemplatePropsInterface } from 'common/module/building-review/button/template-props.interface';
import { BuildingReviewButtonViewStoreOptionsInterface } from 'common/module/building-review/button/view-store/options.interface';
import { DataStore } from 'common/module/data/store';
import { StatsGtmProviderInterface } from 'common/module/stats/gtm/provider.interface';
import { BuildingReviewFormView } from 'desktop/module/building-review/form/view';
import { buildingReviewStatsGtmWriteReviewCta } from 'desktop/module/building-review/stats/gtm/write-review-cta';

export class BuildingReviewButtonViewStore extends DataStore {
  /**
   * @inheritdoc
   */
  protected state: BuildingReviewButtonTemplatePropsInterface;

  /**
   * Url querystring parameter to trigger the 'write-review' modal
   */
  private readonly WRITE_REVIEW_PARAM: string = 'write_review';

  /**
   * Constructor
   */
  public constructor(
    eventEmitter: EventEmitterInterface,
    private buildingReviewForm: BuildingReviewFormView,
    private statsGtm: StatsGtmProviderInterface,
    private settings: BackendConfigSettingsInterface,
    private windowLocationService: WindowLocationServiceInterface
  ) {
    super(eventEmitter);
  }

  /**
   * @inheritdoc
   */
  public initialize(options: BuildingReviewButtonViewStoreOptionsInterface): void {
    this.buildingReviewForm.initialize(options);

    this.state = {
      onClickButton: this.onClickButton,
    };

    // Checking if auto opening allow and there is write review url querystring parameter
    if (options.hasModalAutoOpening && this.windowLocationService.getQueryData()[this.WRITE_REVIEW_PARAM]) {
      this.buildingReviewForm.setOpen(true);
    }
  }

  /**
   * @inheritdoc
   */
  public getState(): BuildingReviewButtonTemplatePropsInterface {
    return this.state;
  }

  /**
   * Click on write review button
   */
  private onClickButton = (e: Event) => {
    e.preventDefault();

    this.statsGtm.send(buildingReviewStatsGtmWriteReviewCta(settingsGetPageType(this.settings)));
    this.buildingReviewForm.setOpen(true);
  };
}
